import type { ReactNode } from 'react'
import styles from './MemberSignupView.module.css'
import { Form } from '@/components/Form'
import { ButtonCollection } from '@/components/ButtonCollection'
import { Button } from '@/components/Button'

export interface MemberSignupViewProps {
  onSubmit: () => unknown
  isSubmitPending: boolean
  children: ReactNode
}

export function MemberSignupView({
  onSubmit,
  isSubmitPending,
  children,
}: MemberSignupViewProps) {
  return (
    <div className={styles.root}>
      <Form className={styles.inputGroup} onSubmit={() => onSubmit()}>
        {children}
        <ButtonCollection>
          <Button
            label="Register"
            variant="primary"
            type="submit"
            isDisabled={isSubmitPending}
            isPending={isSubmitPending}
          />
        </ButtonCollection>
      </Form>
    </div>
  )
}
